import * as React from 'react';
import { connect } from 'react-redux';
import AppActions from '../../app/app_actions';
import { AppConstants } from '../../constants/AppConstants';
import * as agui from 'arm-gui/dist/controls';
import ProdottoActions from './prodotto_actions';
import ConfirmModalDeleteV4 from '../shared/confirmModalDeleteV4.jsx';
import { Utils, DateFormatter, domain, UiUtils, i18n, isAuth, NumberFormatter } from 'arm-common';
import garanzie from '../garanzie/garanzie_reducer';


class ProvvigioniPassiveEdit extends React.Component {

    constructor(props) {
        super(props);
        this.componentName = '[ProvvigioniPassiveEdit.jsx] ';
        this.arrayChangeHandlerProvvigioniPassive = this.arrayChangeHandlerProvvigioniPassive.bind(this);
        this.inputChangeHandlerProvvigioniPassiveFilters = this.inputChangeHandlerProvvigioniPassiveFilters.bind(this);
        this.applicaSuTuttiProvvigioniPassButton = this.applicaSuTuttiProvvigioniPassButton.bind(this);
        this.deleteGaranzieDataDelete = this.deleteGaranzieDataDelete.bind(this);
        this.deleteProvviggioniEdit = this.deleteProvviggioniEdit.bind(this);
        this.salvaProvPassive = this.salvaProvPassive.bind(this);
        this.showConfirmDeletePanel = this.showConfirmDeletePanel.bind(this);
        this.inizioDelete = this.inizioDelete.bind(this);
        this.salvaDeletePassive = this.salvaDeletePassive.bind(this);
        this.cancelEditProvvPassiveButton = this.cancelEditProvvPassiveButton.bind(this);
        this.showConfirmPanel = this.showConfirmPanel.bind(this);
        this.inizioSalvataggio = this.inizioSalvataggio.bind(this)
        this.state = {
            validation: new Map(),
            showConfirmDelete: false,
            showConfirm: false
        }
    }

    componentDidMount() {
        console.log(this.componentName + 'componentDidMount');
    }

    showConfirmPanel() {
        this.props.showPopUP(!this.state.showConfirm);
        this.setState({
            showConfirm: !this.state.showConfirm
        })
    }

    showConfirmDeletePanel() {
        this.props.showPopUP(!this.state.showConfirmDelete);
        this.setState({
            showConfirmDelete: !this.state.showConfirmDelete
        })
    }

    inizioDelete() {
        if (this.validateDeleteProvPassive()) {
            this.showConfirmDeletePanel();
        }
    }

    inizioSalvataggio() {
        if (this.validateProvPassive()) {
            this.showConfirmPanel();
        }
    }

    arrayChangeHandlerProvvigioniPassive(e) {
        e.preventDefault();
        console.log(this.componentName + 'arrayChangeHandlerProvvigioniPassive');
        let value = e.target.value;
        let index = e.target.id;
        let name = e.target.name;

        if (name === 'percRinnovo' && value === "") {
            value = null;
        }

        if (this.state.validation.has(Number(index))) {
            this.state.validation.delete(Number(index));
        }
        this.props.updateListaProvvigioniPassive(name, index, value);
    }

    inputChangeHandlerProvvigioniPassiveFilters(e) {
        console.log(this.componentName + 'inputChangeHandlerProvvigioniPassiveFilters');
        if (e !== null && e !== undefined) {
            let value = e.target.value;
            let id = e.target.id;
            if (id === "dataInizio" && value === "") {
                value = null;
            } else if (id === "intermediario") {
                if (value === "[object Object]") {
                    value = null;
                }
            } else if (id === "garanzie") {
                if (value === "[object Object]") {
                    value = null;
                }
            }

            let type = e.target.type;
            if (type === "number" && value === "") {
                value = null;
            }
            this.props.inputChangeHandlerProvvigioniPassiveFilters(id, value);
        }
    }

    applicaSuTuttiProvvigioniPassButton() {
        this.setState({
            showConfirm: false
        })
        this.props.applicaSuTuttiProvvigioniPassButton();
        // non si fa update qunado lo stato cambia, quindi faccio una cambia fictiva dello stato per forzare la reRender.
    }

    deleteGaranzieDataDelete() {
        let listaGaranzieComboDelete = [];
        listaGaranzieComboDelete = this.props.prodotto.listaProvvigioniPassive.map(
            (item, index) =>
            (
                (this.props.provvigioniPassiveFilters.intermediario === undefined
                    || this.props.provvigioniPassiveFilters.intermediario === null
                    || parseInt(this.props.provvigioniPassiveFilters.intermediario) === parseInt(item.intermediario.id))
                &&
                (this.props.provvigioniPassiveFilters.garanzie === undefined
                    || this.props.provvigioniPassiveFilters.garanzie === null
                    || parseInt(this.props.provvigioniPassiveFilters.garanzie) === parseInt(item.garanzia.id))
            )

        );
        this.props.deleteGaranzieDataDelete(listaGaranzieComboDelete);
    }

    deleteProvviggioniEdit() {

        this.deleteGaranzieDataDelete();
        this.props.deleteProvviggioniEdit().then(
            resolve => {
                this.props.history.push({ pathname: '/prodotto/details', state: { id: this.props.prodotto.id } })
            },
            reject => {
                console.log(this.componentName + " deleteProvviggioniEdit() -> deleteProvviggioniEdit KO");
            }
        )
    }
    salvaDeletePassive() {
        console.log(this.componentName + 'salvaProvPassive');
        this.props.showPopUP(false);
        //  if (this.validateProvPassive()) {
        this.showConfirmPanel();
        this.props.salvaProvPassive().then(
            resolve => {
                this.props.history.push({ pathname: '/prodotto/details', state: { id: this.props.prodotto.id } })
            },
            reject => {
                console.log(this.componentName + " salvaProvPassive() -> salvaProvPassive KO");
            }
        )
    }

    salvaProvPassive() {
        console.log(this.componentName + 'salvaProvPassive');
        this.props.showPopUP(false);
        if (this.validateProvPassive()) {
            this.showConfirmPanel();
            this.props.salvaProvPassive().then(
                resolve => {
                    this.props.history.push({ pathname: '/prodotto/details', state: { id: this.props.prodotto.id } })
                },
                reject => {
                    console.log(this.componentName + " salvaProvPassive() -> salvaProvPassive KO");
                }
            )
        }
    }

    validateProvPassive() {
        let validation = new Map();
        let unoProv = this.props.provvigioniPassiveFilters;
        this.props.prodotto.listaProvvigioniPassive.forEach((element, index) => {
											  
            if (((unoProv.intermediario !== null && unoProv.intermediario !== undefined && unoProv.intermediario !== "") &&
                (unoProv.garanzie !== null && unoProv.garanzie !== undefined && unoProv.garanzie !== ""))) {

                if ((parseInt(unoProv.intermediario) === element.intermediario.id) && (parseInt(unoProv.garanzie) === element.garanzia.id)) {
                    if (element.prodottoGaranziaProvvigioni.dataInizio === undefined || element.prodottoGaranziaProvvigioni.dataInizio === null || element.prodottoGaranziaProvvigioni.dataInizio === "") {
                        validation.set(index, i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));

                    }
                    if (element.prodottoGaranziaProvvigioni && element.prodottoGaranziaProvvigioni.percEmissione === undefined || element.prodottoGaranziaProvvigioni.percEmissione === null || element.prodottoGaranziaProvvigioni.percEmissione === "") {
                        validation.set(index, i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));

                    }
                }
            } else if ((unoProv.intermediario !== null && unoProv.intermediario !== undefined && unoProv.intermediario !== "")) {
                if (parseInt(unoProv.intermediario) === element.intermediario.id) {
                    if (element.prodottoGaranziaProvvigioni.dataInizio === undefined || element.prodottoGaranziaProvvigioni.dataInizio === null || element.prodottoGaranziaProvvigioni.dataInizio === "") {
                        validation.set(index, i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
                    }
                    if (element.prodottoGaranziaProvvigioni && element.prodottoGaranziaProvvigioni.percEmissione === undefined || element.prodottoGaranziaProvvigioni.percEmissione === null || element.prodottoGaranziaProvvigioni.percEmissione === "") {
                        validation.set(index, i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
                    }
                }
            } else if (unoProv.garanzie !== null && unoProv.garanzie !== undefined && unoProv.garanzie !== "") {
                if (parseInt(unoProv.garanzie) === element.garanzia.id) {
                    if (element.prodottoGaranziaProvvigioni.dataInizio === undefined || element.prodottoGaranziaProvvigioni.dataInizio === null || element.prodottoGaranziaProvvigioni.dataInizio === "") {
                        validation.set(index, i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
                    }
                    if (element.prodottoGaranziaProvvigioni && element.prodottoGaranziaProvvigioni.percEmissione === undefined || element.prodottoGaranziaProvvigioni.percEmissione === null || element.prodottoGaranziaProvvigioni.percEmissione === "") {
                        validation.set(index, i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
                    }
                }
            }
            else {
                if (element.prodottoGaranziaProvvigioni.dataInizio === undefined || element.prodottoGaranziaProvvigioni.dataInizio === null || element.prodottoGaranziaProvvigioni.dataInizio === "") {
                    validation.set(index, i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));

                }
                if (element.prodottoGaranziaProvvigioni && element.prodottoGaranziaProvvigioni.percEmissione === undefined || element.prodottoGaranziaProvvigioni.percEmissione === null || element.prodottoGaranziaProvvigioni.percEmissione === "") {
                    validation.set(index, i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
                }
            }

        });
        this.setState({ validation: validation });

        if (validation.size === 0) {
            return true
        }
        return false;
    }

    validateDeleteProvPassive() {
        let validation = new Map();
        let unoProv = this.props.provvigioniPassiveFilters;

        this.props.prodotto.listaProvvigioniPassive.forEach((element, index) => {
            if (((unoProv.intermediario !== null && unoProv.intermediario !== undefined && unoProv.intermediario !== "") &&
                (unoProv.garanzie !== null && unoProv.garanzie !== undefined && unoProv.garanzie !== ""))) {
                    if ((parseInt(unoProv.intermediario) === element.intermediario.id) && (parseInt(unoProv.garanzie) === element.garanzia.id)) {

                if (element.prodottoGaranziaProvvigioni.dataInizio !== undefined && element.prodottoGaranziaProvvigioni.dataInizio !== null && element.prodottoGaranziaProvvigioni.dataInizio !== ""
                    || element.prodottoGaranziaProvvigioni.percRinnovo !== undefined && element.prodottoGaranziaProvvigioni.percRinnovo !== null && element.prodottoGaranziaProvvigioni.percRinnovo !== ""
                    || element.prodottoGaranziaProvvigioni.percEmissione !== undefined && element.prodottoGaranziaProvvigioni.percEmissione !== null && element.prodottoGaranziaProvvigioni.percEmissione !== ""
                ) {
                    validation.set(i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
                    return;
                }
            }

            } else if ((unoProv.intermediario !== null && unoProv.intermediario !== undefined && unoProv.intermediario !== "")) {
                if (parseInt(unoProv.intermediario) === element.intermediario.id) {
                if (element.prodottoGaranziaProvvigioni.dataInizio !== undefined && element.prodottoGaranziaProvvigioni.dataInizio !== null && element.prodottoGaranziaProvvigioni.dataInizio !== ""
                    || element.prodottoGaranziaProvvigioni.percRinnovo !== undefined && element.prodottoGaranziaProvvigioni.percRinnovo !== null && element.prodottoGaranziaProvvigioni.percRinnovo !== ""
                    || element.prodottoGaranziaProvvigioni.percEmissione !== undefined && element.prodottoGaranziaProvvigioni.percEmissione !== null && element.prodottoGaranziaProvvigioni.percEmissione !== ""
                ) {
                    validation.set(i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
                    return;
                }
            }

            } else if (unoProv.garanzie !== null && unoProv.garanzie !== undefined && unoProv.garanzie !== "") {
                if (parseInt(unoProv.garanzie) === element.garanzia.id) {
                if (element.prodottoGaranziaProvvigioni.dataInizio !== undefined && element.prodottoGaranziaProvvigioni.dataInizio !== null && element.prodottoGaranziaProvvigioni.dataInizio !== ""
                    || element.prodottoGaranziaProvvigioni.percRinnovo !== undefined && element.prodottoGaranziaProvvigioni.percRinnovo !== null && element.prodottoGaranziaProvvigioni.percRinnovo !== ""
                    || element.prodottoGaranziaProvvigioni.percEmissione !== undefined && element.prodottoGaranziaProvvigioni.percEmissione !== null && element.prodottoGaranziaProvvigioni.percEmissione !== ""
                ) {
                    validation.set(i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
                    return;
                }
            }

            } else {      
                    if (element.prodottoGaranziaProvvigioni.dataInizio !== undefined && element.prodottoGaranziaProvvigioni.dataInizio !== null && element.prodottoGaranziaProvvigioni.dataInizio !== ""
                        || element.prodottoGaranziaProvvigioni.percRinnovo !== undefined && element.prodottoGaranziaProvvigioni.percRinnovo !== null && element.prodottoGaranziaProvvigioni.percRinnovo !== ""
                        || element.prodottoGaranziaProvvigioni.percEmissione !== undefined && element.prodottoGaranziaProvvigioni.percEmissione !== null && element.prodottoGaranziaProvvigioni.percEmissione !== ""
                    ) {
                        validation.set(i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
                        return;
                    }       
            }
        });
        this.setState({ validation: validation });

        if (validation.size !== 0) {
            return true;
        }
        this.props.addNotify('WARNING', i18n('ARM_CORE_PRODUCT.PRODOTTO.PROVVIGINI_DELETE_PASSIVE', 'Non hai Provvigioni passive da eliminare'))
        return false
    }

    cancelEditProvvPassiveButton() {
        this.props.history.push({ pathname: '/prodotto/details', state: { id: this.props.prodotto.id } });

    }
    render() {
        console.log(this.componentName + 'render');
        let listaIntermediariCombo = [];
        let listaIntermediari = this.props.prodotto.listaProdottoIntermediarioPojo;
        if (listaIntermediari !== undefined && listaIntermediari !== null) {
            listaIntermediariCombo = listaIntermediari.filter(intermediario => intermediario.selezionato === true)
            listaIntermediariCombo.forEach((element, index) => {
                listaIntermediariCombo[index].id = listaIntermediariCombo[index].intermediario.id;
                listaIntermediariCombo[index].denominazione = listaIntermediariCombo[index].intermediario.denominazione;
            });

        }
        let listaGaranzieCombo = [];
        let listaGaranzieComboNew = [];
        const listaGaranzie = this.props.prodotto.listaProvvigioniPassive;
        if (listaGaranzie !== undefined && listaGaranzie !== null) {
            listaGaranzieCombo = listaGaranzie.slice();
            const duplicateName = new Set();
            // Iterate through the array
            listaGaranzieCombo.forEach((element) => {
                const nome = element.garanzia.nome;
                // Check if the `nome` has not been seen before
                if (!duplicateName.has(nome)) {
                    // Add `nome` to the Set
                    duplicateName.add(nome);
                    // Push the new item to the new array
                    listaGaranzieComboNew.push({
                        id: element.garanzia.id,
                        nome: nome
                    });															
					 
                }
            });
        }

        return (
            <agui.aCardV4 className="mt-3 mb-3 inner-card">
                <agui.aCardV4Header>

                    <div className="col-md-6 col-sm-6 col-xs-6 " style={{ fontSize: "x-large", fontWeight: "bold" }}>
                        {i18n('ARM_CORE_PRODUCT.PRODOTTO.PROVV_PASSIVE_DEL_PRODOTTO', 'Provvigioni passive del prodotto')}  {this.props.prodotto.id}: {this.props.prodotto.nome}
                    </div>
                </agui.aCardV4Header>
                <agui.aCardV4Body>
                    <div className="row mt-8">
                        <div className="col col-sm-4 col-md-4 col-lg-4">

                            <agui.ASelectV4
                                id="intermediario"
                                onChange={this.inputChangeHandlerProvvigioniPassiveFilters}
                                value={this.props.provvigioniPassiveFilters ? this.props.provvigioniPassiveFilters.intermediario : ""}
                                label={i18n('ARM_CORE_PRODUCT.PRODOTTO.INTERMEDIARIO', 'Intermediario')}
                                items={listaIntermediariCombo}
                                valueKey="id"
                                labelKey="denominazione"
                            />

                        </div>
                        <div className="col col-sm-4 col-md-4 col-lg-4">

                            <agui.ASelectV4
                                id="garanzie"
                                onChange={this.inputChangeHandlerProvvigioniPassiveFilters}
                                //  value={this.props.listaGaranzieCombo ? this.props.listaGaranzieCombo.nome : ""}
                                value={this.props.provvigioniPassiveFilters ? this.props.provvigioniPassiveFilters.garanzie : ""}
                                label={i18n('ARM_CORE_PRODUCT.SHARED.GARANZIA', 'Garanzie')}
                                items={listaGaranzieComboNew}
                                valueKey="id"
                                labelKey="nome"
                            />
                        </div>

                    </div>

                    <div className="row ">
                        <div className="col col-sm-4 col-md-4 col-lg-4">
                            <div className="form-group">
                                <label htmlFor="dataInizio"> {i18n('ARM_CORE_PRODUCT.PRODOTTO.DATA_INIZIO', 'Data Inizio')} </label>
                                <input className="form-control" type="date"
                                    onChange={this.inputChangeHandlerProvvigioniPassiveFilters}
                                    value={this.props.provvigioniPassiveFilters ? this.props.provvigioniPassiveFilters.dataInizio : ""}
                                    validation={this.state.validation}
                                    id="dataInizio" name="dataInizio" />
                            </div>
                        </div>
										
							

                        <div className="col col-sm-4 col-md-4 col-lg-4">
                            <agui.ATextInputV4 id="percEmissione" type="number"
                                value={this.props.provvigioniPassiveFilters ? this.props.provvigioniPassiveFilters.percEmissione : null}
                                label={i18n('ARM_CORE_PRODUCT.PRODOTTO.PERC_EMISSIONE', '% Emissione')}
                                validation={this.state.validation}
                                onChange={this.inputChangeHandlerProvvigioniPassiveFilters} />
                        </div>
                    </div>

                    <div className="row ">
                        <div className="col col-sm-4 col-md-4 col-lg-4">
                            <agui.ATextInputV4 id="percRinnovo" type="number"
                                value={this.props.provvigioniPassiveFilters ? this.props.provvigioniPassiveFilters.percRinnovo : null}
                                label={i18n('ARM_CORE_PRODUCT.PRODOTTO.PERC_RINNOVO', '% Rinnovo')}
                                validation={this.state.validation}
                                onChange={this.inputChangeHandlerProvvigioniPassiveFilters} />
                        </div>

                        <div style={
                            {
                                marginTop: 27,
                            }
						 
                        } className="col col-sm-2 col-md-2 col-lg-2">
                            <agui.aButton bs="primary" icon="fas fa-arrow-alt-circle-right" onClick={this.applicaSuTuttiProvvigioniPassButton}> {i18n('ARM_CORE_PRODUCT.PRODOTTO.APPLICA_SU_TUTTE', 'APPLICA SU TUTTE')}</agui.aButton>
                        </div>
                        < div
                            style={
                                {
                                    marginTop: 27,
                                }
                            } className="col col-sm-2 col-md-2 col-lg-2">
																	 
                            <agui.aButton icon="fas fa-trash" className="btn btn-danger" style={{}} onClick={this.inizioDelete}>{i18n('ARM_CORE_PRODUCT.PRODOTTO.DELETE', 'DELETE SU TUTTE')}</agui.aButton>
                        </div>


                    </div>

                    <div className="mt-4">
                        <table style={{
                            textAlign: 'center',
                            verticalAlign: 'middle'
                        }} className="table table-bordered" >
                            <thead>
                                <tr>
                                    <td>{i18n('ARM_CORE_PRODUCT.PRODOTTO.INTERMEDIARIO', 'Intermediario')}</td>
                                    <td>{i18n('ARM_CORE_PRODUCT.SHARED.GARANZIA', 'Garanzia')}</td>
                                    <td>{i18n('ARM_CORE_PRODUCT.PRODOTTO.DATA_INIZIO', 'Data Inizio')}</td>
                                    <td>{i18n('ARM_CORE_PRODUCT.PRODOTTO.PERC_EMISSIONE', '% Emissione')}</td>
                                    <td>{i18n('ARM_CORE_PRODUCT.PRODOTTO.PERC_RINNOVO', '% Rinnovo')}</td>
                                </tr>
                            </thead>
                            <tbody >
                                {!listaIntermediariCombo || listaIntermediariCombo.length === 0 ?

                                    <tr>
                                        <td style={{ textAlign: "center" }} colspan="5">{i18n('ARM_CORE_PRODUCT.PRODOTTO.NESSUN_INTERMEDIARIO_LEGATO_AL_PRODOTTO', 'Nessun Intermediario legato al prodotto')}</td>

                                    </tr>


                                    : !this.props.prodotto.listaProvvigioniPassive || this.props.prodotto.listaProvvigioniPassive.length === 0 ?
                                        <tr>
                                            <td style={{ textAlign: "center" }} colspan="5">{i18n('ARM_CORE_PRODUCT.PRODOTTO.NESSUNA_GARANZIA_ASSOCIATA_AL_PRODOTTO', 'Nessuna garanzia di tipo copertura "Obbligatoria" o "Facoltativa" non è legata a questo prodotto ')}
                                            </td>
                                        </tr>
                                        :
                                        this.props.prodotto.listaProvvigioniPassive.map(
                                            (item, index) =>
                                                (
                                                    (this.props.prodotto.listaProvvigioniPassive[index].elimina != true) &&
                                                    (this.props.provvigioniPassiveFilters.intermediario === undefined
                                                        || this.props.provvigioniPassiveFilters.intermediario === null
                                                        || parseInt(this.props.provvigioniPassiveFilters.intermediario) === parseInt(item.intermediario.id))
                                                    &&
                                                    (this.props.provvigioniPassiveFilters.garanzie === undefined
                                                        || this.props.provvigioniPassiveFilters.garanzie === null
                                                        || parseInt(this.props.provvigioniPassiveFilters.garanzie) === parseInt(item.garanzia.id))
                                                )
                                                &&
                                                < tr key={index} >
                                                    <td style={{
                                                        textAlign: 'center',
                                                        verticalAlign: 'middle'
                                                    }} >{item.intermediario.denominazione}</td>
                                                    <td style={{
                                                        textAlign: 'center',
                                                        verticalAlign: 'middle'
                                                    }}>{item.garanzia ? item.garanzia.nome : null}  {item.garanzia.nomeProdottoBaseGar ? (<b><i>- {item.garanzia.nomeProdottoBaseGar} </i></b>) : null}</td>
                                                    <td
                                                    // style={{
                                                    //     textAlign: 'center',
                                                    //     verticalAlign: 'middle'
                                                    // }}
                                                    >
                                                        {/* <div className="form-group" >
                                                            <label htmlFor="dataInizio" ></label> */}
                                                        <agui.ATextInputV4 id={index}
                                                            // {/* <input  */}
                                                            label=""
                                                            validation={this.state.validation}
                                                            className="form-control" type="date"
                                                            onChange={this.arrayChangeHandlerProvvigioniPassive}
                                                            // disabled={item.prodottoGaranziaProvvigioni.id !== undefined && item.prodottoGaranziaProvvigioni.id !== null}
                                                            value={item.prodottoGaranziaProvvigioni ? DateFormatter.formatDateFromMilisToString(item.prodottoGaranziaProvvigioni.dataInizio) : ""}
                                                            name="dataInizio" />
                                                    </td>

                                                    <td>
                                                        <agui.ATextInputV4 id={index} type="number"
                                                            value={item.prodottoGaranziaProvvigioni ? item.prodottoGaranziaProvvigioni.percEmissione : null}
                                                            validation={this.state.validation}
                                                            label=""
                                                            // disabled={item.prodottoGaranziaProvvigioni.id !== undefined && item.prodottoGaranziaProvvigioni.id !== null}
                                                            name="percEmissione"
                                                            eventParam={item.percEmissione}
                                                            onChange={this.arrayChangeHandlerProvvigioniPassive} />

                                                    </td>
                                                    <td>
                                                        <agui.ATextInputV4 id={index} type="number"
                                                            value={item.prodottoGaranziaProvvigioni ? item.prodottoGaranziaProvvigioni.percRinnovo : null}
                                                            label=""
                                                            // disabled={item.prodottoGaranziaProvvigioni.id !== undefined && item.prodottoGaranziaProvvigioni.id !== null}
                                                            name="percRinnovo"
                                                            eventParam={item.percRinnovo}
                                                            onChange={this.arrayChangeHandlerProvvigioniPassive} />

                                                    </td>
                                                </tr>

                                        )}
                            </tbody>
                        </table>
                    </div>
                    <agui.ConfirmModalSaveV4
                        show={this.state.showConfirm}
                        saveOnClick={this.salvaProvPassive}
                        onClose={this.showConfirmPanel} />

                    <ConfirmModalDeleteV4
                        show={this.state.showConfirmDelete}
                        deleteOnClick={this.deleteProvviggioniEdit}
                        onClose={this.showConfirmDeletePanel} />

                </agui.aCardV4Body>
                <agui.aCardFooter>
                    <div>
                        <agui.aButton bs="primary" className="mr-2" icon="fas fa-save" onClick={this.inizioSalvataggio}>{i18n('ARM_CORE_PRODUCT.SHARED.SALVA', 'Salva')}</agui.aButton>
                        <agui.aButton bs="secondary" className="float-right mr-5" onClick={this.cancelEditProvvPassiveButton}>{i18n('ARM_CORE_PRODUCT.SHARED.ANNULLA', 'Annulla')}</agui.aButton>
                    </div>
                </agui.aCardFooter>
            </agui.aCardV4>
        );
    }

};
function mapStateToProps(state) {
    return {
        showConfirm: state.app.showPopUp,
        // showConfirmDeletePanel: state.app.showConfirmDeletePanel,
        prodotto: state.prodotto.detailsProdotto,
        provvigioniPassiveFilters: state.prodotto.provvigioniPassiveFilters,
        listaIntermediari: state.prodotto.listaIntermediari

    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateListaProvvigioniPassive(name, index, value) {
            return dispatch(ProdottoActions.updateListaProvviggioniPassive(name, index, value))
        },
        inputChangeHandlerProvvigioniPassiveFilters(id, value) {
            return dispatch(ProdottoActions.inputChangeHandlerProvvigioniPassiveFilters(id, value));
        },
        applicaSuTuttiProvvigioniPassButton() {
            return dispatch(ProdottoActions.applicaFiltriSuTuttiProvvigioniPassive());
        },
        deleteProvviggioniEdit() {
            return dispatch(ProdottoActions.deleteProvviggioniEdit());
        },
        changeSelectedTab(idTab) {
            return dispatch(ProdottoActions.changeSelectedTab(idTab));
        },
        salvaProvPassive() {
            return dispatch(ProdottoActions.salvaProvPassive());
        },
        //added for saving after deleting
        salvaDeletePassive() {
            return dispatch(ProdottoActions.salvaProvPassive());
        },
        showPopUP(isShow) {
            return dispatch(AppActions.showPopUp(isShow))
        },
        deleteGaranzieDataDelete(value) {
            return dispatch(ProdottoActions.deleteGaranzieDataDelete(value));
        },
        addNotify(tipo, messaggio) {
            return dispatch(AppActions.addNotify(tipo, messaggio));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProvvigioniPassiveEdit);